import React from 'react';
import {StreamBankLink} from "../../StreamBankLink";

export const DefaultActivityTitle = props => {
    const {contextNodeActivity} = props;
    const {
        Activity: activity = null,
        ContextNodeDetails: contextNodeDetails = null,
    } = contextNodeActivity;
    
    const titleString = activity?.data?.title ?? contextNodeDetails?.name;
    
    if(contextNodeDetails?.link) {
        return <StreamBankLink Context={contextNodeDetails.link}>{titleString}</StreamBankLink>;
    }
    
    return titleString;
};


